import { zIndexes } from '../../../variables'
import colors from '../../../theming/docusign-themes/olive/colors'
import { CreateFocusCss } from '../../../styles'

const ANIM_TIMING = 300

export default {
  SkipNav: {
    transition: `margin ${ANIM_TIMING}ms ease-out`,
    alignItems: 'center',
    background: colors.gray9_alpha90,
    color: colors.white,
    justifyContent: 'center',
    display: 'flex',
    height: '28px',
    outline: 'none',
    position: 'absolute',
    textAlign: 'center',
    textDecoration: 'underline',
    width: '100%',
    marginTop: '-28px',
    zIndex: zIndexes.SkipNav,

    ...CreateFocusCss({
      transition: `margin ${ANIM_TIMING}ms ease-in`,
      marginTop: '0',
    }),
  },
} as const
